import {omit} from 'lodash';
import {ColumnSpec} from '@xh/hoist/cmp/grid';
import {DEFAULT_GRID_SPEC, GridSpec, GridSpecCapabilities} from '../../../../cmp/gridSpec/GridSpecTypes';
import {positionsBaseColumn} from '../positions/PositionsGridSpec';

/**
 * Movers rows are positions totalled by ticker, so they offer the same columns as the Positions widget. The quadrants
 * set their own sort and filter, so the spec holds columns and display options only.
 */
export const moversCapabilities: GridSpecCapabilities = {
    grouping: 'none',
    filtering: 'none',
    totals: false,
    leafRows: false,
    sorting: false
};

export const moversDefaultSpec: GridSpec = {
    ...DEFAULT_GRID_SPEC,
    columns: [{field: 'ticker'}, {field: 'priceChangePct'}, {field: 'intraday'}, {field: 'pnlDly'}, {field: 'marketValue'}]
};

const MOVERS_COLUMNS: Record<string, ColumnSpec> = {
    // Fixed width, so the tickers line up across the quadrants
    ticker: {...positionsBaseColumn('ticker'), sortable: false, width: 80, minWidth: 80},
    // Today's path takes up the slack, so a wide quadrant fills with chart rather than space
    intraday: {...omit(positionsBaseColumn('intraday'), 'width'), flex: 1, minWidth: 80}
};

export const moversBaseColumn = (field: string): ColumnSpec => MOVERS_COLUMNS[field] ?? positionsBaseColumn(field);
